import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../../translations';

export type TitleValue = { title: string | null };
type TitleInputProps = Pick<FormContextValues<TitleValue>, 'register'>;

export const TitleInput = (props: TitleInputProps): JSX.Element => {
   const controller = props.register('title', {
      required: false,
      maxLength: 50,
   });

   return <TextInput testId={'title'} label={personnelTranslationKeys.academicTitle} controller={controller} />;
};
